import { render, staticRenderFns } from "./PoiSubFreeTime.vue?vue&type=template&id=10515c8c"
import script from "./PoiSubFreeTime.js?vue&type=script&lang=js&external"
export * from "./PoiSubFreeTime.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports